export default __webpack_public_path__ + "static/media/6.15f068b8.png";